// Helpers de tracking (DRY) — un seul endroit pour journaliser les événements
// réels vers /track et /track-search. Tous les appels sont « fire and forget »
// (jamais bloquants, jamais d'erreur remontée à l'utilisateur).
import { http } from "@/lib/api";

// Source d'attribution éventuellement mémorisée (badge, carte partageable, …).
const source = () => {
  try {
    return sessionStorage.getItem("atlas:src") || "inconnu";
  } catch {
    return "inconnu";
  }
};

// Événement sur une fiche solution : type = "vue" | "interaction" | "commercial".
export const track = (solutionId, type, cible, src) => {
  if (!solutionId) return;
  http.post("/track", { solution_id: solutionId, type, cible, source: src || source() }).catch(() => {});
};

// Événement d'engagement hors fiche : entite = "idee" | "article" | "formulaire".
export const trackEntite = (entite, cible, entiteId) => {
  http.post("/track", { entite, cible, entite_id: entiteId ? String(entiteId) : "", source: source() }).catch(() => {});
};

// Recherche du catalogue (Intelligence marché).
export const trackSearch = (terme, secteur) => {
  if (!terme) return;
  http.post("/track-search", { terme, secteur: secteur || "" }).catch(() => {});
};
